<template lang="pug">
    div
        // pre
        horizontal-bar-chart(
            :chart-data="chartData.dataCollection"
            :options="chartData.options"
            :height="chartHeight"
            :plugins="chartPlugins"
        )
        div(v-if="showSlider")
            p 左側滑桿為
                span(style='background-color: yellow')
                    strong 訂閱起始日
            p 右側滑桿為
                span(style='background-color: yellow')
                    strong 今日
            Slider(
                v-if="daysInMonth.length > 0"
                v-model="sliderValue"
                range
                :marks="marks"
                :min=0
                :max="daysInMonth.length - 1"
                @on-change="updateSlider"
                :tip-format="sliderTickFormat"
            )
</template>
<script>
import HorizontalBarChart from "@/components/horizontalBarChart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";

export default {
    name: "Test",
    props: {
        showSlider: { type: Boolean, default: false },
        currentCost: { type: Number, default: 0 },
        estimateCost: { type: Number, default: 0 },
        subscriptionPeriodStart: {
            type: Date,
            default: () => moment().startOf("month").toDate(),
        },
        estimateCostFrom: { type: Date, default: () => new Date() },
        chartHeight: { type: Number, default: 38 },
    },
    components: { HorizontalBarChart },
    data() {
        return {
            daysInMonth: [],
            chartPlugins: [ChartDataLabels],
            chartData: {
                dataCollection: {},
                options: {},
            },
            sliderValue: [this.subscriptionPeriodStart.getDate() - 1, this.estimateCostFrom.getDate() - 1],
            fullMarks: {},
            marks: {},
        };
    },
    async mounted() {
        this.daysInMonth = this.getDaysOfMonth();
        this.daysInMonth.forEach((day, i) => {
            if (i % 3 == 0) this.marks[i] = day;
            else this.marks[i] = "";
            this.fullMarks[i] = day;
        });
        this.updateSlider(this.sliderValue);
    },
    directives: {},
    methods: {
        sliderTickFormat(value) {
            return this.fullMarks[value];
        },
        getDaysOfMonth() {
            let daysInMonth = moment().daysInMonth();

            return Array.from(new Array(daysInMonth)).map((e, i) =>
                moment()
                    .date(i + 1)
                    .format("MM/DD")
            );
        },
        updateSlider(value) {
            // console.log(value);
            var self = this;
            this.chartData = {
                dataCollection: {
                    // labels: ["當前費用 / 預計費用"],
                    // labels: ["當前費用 / 預計費用"],
                    datasets: [
                        {
                            label: "尚未訂閱",
                            backgroundColor: "rgba(255, 255, 255, .0)",
                            data: [value[0]],
                        },
                        {
                            // label: "訂閱期間費用",
                            label: self.$t("accountInfo.plan.thisMonthCostUsageText"),
                            backgroundColor: "rgba(11, 156, 49, 0.4)",
                            // backgroundColor: this.createDiagonalPattern("green"),
                            // borderColor: "green",
                            borderWidth: 2,
                            data: [value[1] - value[0]],
                        },
                        {
                            // label: "預計產生費用",
                            label: self.$t("accountInfo.plan.estimatedCostText"),
                            backgroundColor: this.createDiagonalPattern("rgba(11, 156, 49, 0.8)"),
                            borderWidth: 0,
                            data: [this.daysInMonth.length - value[1]],
                        },
                    ],
                },
                options: {
                    plugins: {
                        datalabels: {
                            formatter: (value, context) => {
                                if (context.dataset.data[0] == 0) return "";
                                if (context.datasetIndex == 1) return `$${self.currentCost.toFixed(2)}`;
                                if (context.datasetIndex == 2) return `$${self.estimateCost.toFixed(2)}`;
                                return "";
                            },
                            color: function (context) {
                                if (context.dataset.data[0] == 0) return "";
                                if (context.datasetIndex == 1) return "green";
                                if (context.datasetIndex == 2) return "green";
                            },
                            font: {
                                weight: "bold",
                                size: 16,
                                family: "Josefin Sans",
                            },
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                stacked: true,
                            },
                        ],
                        xAxes: [
                            {
                                stacked: true,
                                min: 1,
                                ticks: {
                                    // fontColor: "green",
                                    callback: function (num, index, values) {
                                        if (num == self.daysInMonth.length)
                                            return moment(self.subscriptionPeriodStart)
                                                .add(1, "months")
                                                .startOf("month")
                                                .format("MM/DD");
                                        // if (num == self.daysInMonth.length) return "次月1號";
                                        // if (num == self.sliderValue[0]) return `訂閱起始日: ${self.daysInMonth[num]}`;
                                        // if (num == self.sliderValue[1]) return `預估起始日: ${self.daysInMonth[num]}`;
                                        if (num % 10 == 0) return self.daysInMonth[num];
                                        return;
                                        // return self.daysInMonth[num];
                                    },
                                    maxTicksLimit: self.daysInMonth.length,
                                },
                                gridLines: {
                                    drawOnChartArea: false,
                                },
                            },
                        ],
                    },
                    legend: {
                        display: true,
                        onClick: (event, legendElement) => {
                            return null;
                        },
                        labels: {
                            filter: function (item, chart) {
                                return !["尚未訂閱"].includes(item.text);
                            },
                        },
                    },
                    tooltips: {
                        enabled: true,
                        callbacks: {
                            label: function (tooltipItems, data) {
                                if (tooltipItems.datasetIndex == 0) return;
                                let label = data.datasets[tooltipItems.datasetIndex].label;
                                return `${label}: ${tooltipItems.xLabel} ${self.$t("accountInfo.trialPeriodUnitText")}`;
                            },
                            title: function () {
                                return null;
                            },
                        },
                    },
                    title: {
                        display: false,
                        text: "費用圖表",
                    },
                },
            };
        },
        // 畫斜線
        createDiagonalPattern(color = "black") {
            let shape = document.createElement("canvas");
            shape.width = 10;
            shape.height = 10;
            let c = shape.getContext("2d");
            c.strokeStyle = color;
            c.beginPath();
            c.moveTo(2, 0);
            c.lineTo(10, 8);
            c.stroke();
            c.beginPath();
            c.moveTo(0, 8);
            c.lineTo(2, 10);
            c.stroke();
            return c.createPattern(shape, "repeat");
        },
    },
    created() {},
    computed: {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Payment/CostUsagePreviewBar.vue